import { Field, Label } from "@headlessui/react";
import { Switch } from "@sellar-io/components";
import type { SupplierProductGetResponseChildType } from "@sellar-io/api-v2/types";
import { Alert } from "../../../../../../components/alert/Alert";
import { apiV2AssertError } from "../../../../../../hooks/api/v2/apiV2Request";
import { useProductStatusUpdate } from "../../../../../../hooks/api/v2/product/useProductStatusUpdate";

export const BasicProductItemVisibility = ({
  product,
  parentActive,
}: {
  product: SupplierProductGetResponseChildType;
  parentActive: boolean;
}) => {
  const productStatusUpdateMutation = useProductStatusUpdate(product.id);
  return (
    <div className="flex flex-col gap-2">
      <Field className="flex items-center justify-between gap-4">
        <div>
          <Label className="font-medium">Visible to customers</Label>
          {!parentActive && (
            <p className="text-sm text-zinc-500">
              Activate the parent product to make this item visible.
            </p>
          )}
        </div>
        <Switch
          checked={
            productStatusUpdateMutation.isPending
              ? productStatusUpdateMutation.variables.active
              : product.active &&
                product._count.activeProductAvailabilityTiers > 0
          }
          disabled={productStatusUpdateMutation.isPending || !parentActive}
          onChange={(active) => productStatusUpdateMutation.mutate({ active })}
        />
      </Field>
      {productStatusUpdateMutation.isPending && (
        <p role="status" className="text-sm text-zinc-500">
          Saving visibility…
        </p>
      )}
      {productStatusUpdateMutation.isError && (
        <Alert
          type="error"
          message={
            apiV2AssertError(productStatusUpdateMutation.error)?.response?.data
              .message ?? "Couldn’t update visibility. Please try again."
          }
        />
      )}
    </div>
  );
};
